import type { LcSelectListOption } from '@lottocom/frontend-components'

import type { SupportedLocales } from '../../types'

export const useLanguageUtils = () => {
  const { locales } = useRuntimeConfig().public
  const { licensedTerritories } = locales
  const { defaultLocale, locale: selectedLocale, t } = useNuxtApp().$i18n

  const licensedTerritory = useLicensedTerritory({ raw: true })

  const currentLocale = computed(() => {
    const selectedLanguage = supportedLocales.value.find(
      (locale) => locale.code === selectedLocale.value,
    )

    if (!defaultLocale) return 'en-US'.toLowerCase()

    const lang =
      selectedLanguage &&
      selectedLanguage.language &&
      licensedTerritories[selectedLanguage.language as keyof typeof licensedTerritories].includes(
        licensedTerritory,
      )
        ? selectedLanguage.language
        : defaultLocale

    return lang.toLowerCase()
  })

  const oldLocale = useState<SupportedLocales['code'] | undefined>(() => undefined)

  const options = computed(() =>
    supportedLocales.value.map<LcSelectListOption>((locale) => ({
      additionalProps: {
        locale: locale.code,
      },
      ariaLabelText: getLocaleLabel(locale.code),
      label: getLocaleLabel(locale.code),
      value: locale.code,
    })),
  )

  const supportedLocales = computed(() => locales.supported as SupportedLocales[])

  const getLocaleLabel = (locale: string) =>
    t(`locale.${locale.toLocaleLowerCase().replace('-', '')}`)

  return {
    currentLocale,
    oldLocale,
    options,
    selectedLocale,
  }
}
